export const tr = {
    'banner-types': 'Yandex Reklam Ağı bloklarındaki reklam örnekleri',
    'banner-types-description':
        'Site ayarları reklamın görünümünü etkiler. Lütfen dikkat! Bazı formatlarda reklam metninin bir kısmı ekrana sığmadığından gösterilemeyebilir.',
    'desktop-and-mobile': 'Masaüstü ve mobil site türleri',
    'more-about-video': 'Video eklentileri ile ilgili daha fazla bilgi',
    'no-video-text': "Video eklentisi bu reklam için kapalı. Eklemek için Sihirbaz'ı kullanabilirsiniz.",
    size: 'Boyut',
    video: 'Video alanları'
};
